// src/store/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { authApi } from "../api/AuthApi";

const tokenFromStorage = (() => {
  try {
    return localStorage.getItem("token");
  } catch (e) {
    return null;
  }
})();

const initialState = {
  user: null,
  token: tokenFromStorage,
  isAuthenticated: !!tokenFromStorage,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, token } = action.payload || {};
      state.user = user || null;
      state.token = token || null;
      state.isAuthenticated = !!token;
      try {
        if (token) localStorage.setItem("token", token);
        if (user) localStorage.setItem("user", JSON.stringify(user));
      } catch (e) {
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      try {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // Wipe the persisted store so back-navigation cannot rehydrate a session.
        localStorage.removeItem("persist:root");
      } catch (e) {}
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
      const { user, token } = action.payload?.data || {};
      if (user && token) {
        authSlice.caseReducers.setCredentials(state, {
          payload: { user, token },
        });
      }
    });
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthToken = (state) => state.auth.token;
